import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da entidade CondicaoPagamento */
export class CondicaoPagamentoFilter implements Filter {
    situacao: number;
    idFormaPagamento: number;
    prazoMedio: number;
    prazoInicial: number;
    multiplo: number;
    quantidadeParcelas: number;


    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        // Forma de Pagamento
        if (this.idFormaPagamento) {
            params = params.append('idFormaPagamento', this.idFormaPagamento.toString());
        }
        // Prazo Médio
        if (this.prazoMedio) {
            params = params.append('prazoMedio', this.prazoMedio.toString());
        }
        // Prazo Inicial
        if (this.prazoInicial) {
            params = params.append('prazoInicial', this.prazoInicial.toString());
        }
        // Multiplo
        if (this.multiplo) {
            params = params.append('multiplo', this.multiplo.toString());
        }
        // Quantidade de Parcelas
        if (this.quantidadeParcelas) {
            params = params.append('quantidadeParcelas', this.quantidadeParcelas.toString());
        }

        return params;
    }

    clear() {
        this.situacao = null;
        this.idFormaPagamento = null;
        this.prazoMedio = null;
        this.prazoInicial = null;
        this.multiplo = null;
        this.quantidadeParcelas = null;
    }
}

